import { __assign } from "tslib";
import { useIdentity } from '@office-start/identity-service';
import { useIsSubscribedUser } from '@office-start/subscription-info-service';
import { useUserEntitlements } from '@office-start/user-entitlements-service';
import { useCallback, useContext, useMemo } from 'react';
import { launchDime, warmupDimeInternal } from '../operations';
import { DimeActionCreatorsContext } from '../store';
import { useWarmupDimeOptions } from './useWarmupDimeOptions';
export var useDime = function (_a) {
    var _b;
    var experiences = _a.experiences, _c = _a.disableSubscriptionCheck, disableSubscriptionCheck = _c === void 0 ? false : _c, _d = _a.disableWarmup, disableWarmup = _d === void 0 ? false : _d;
    var launchDimeOptions = useWarmupDimeOptions();
    var dimeActionCreators = useContext(DimeActionCreatorsContext);
    var userEntitlements = useUserEntitlements().data;
    var identity = useIdentity().data;
    var isSubscribedUser = useIsSubscribedUser();
    var executeDimeFlow = useCallback(function (dimeExperience, targetUrl) {
        if (!launchDimeOptions) {
            return;
        }
        launchDime(__assign(__assign({}, launchDimeOptions), { dimeActionCreators: dimeActionCreators, dimeExperience: dimeExperience, targetUrl: targetUrl }));
    }, [launchDimeOptions, dimeActionCreators]);
    return useMemo(function () {
        var _a;
        // Upsell is only for consumer.
        if (!(identity === null || identity === void 0 ? void 0 : identity.isMsa)) {
            return undefined;
        }
        // Do not show upsell for subscribed users
        if (isSubscribedUser && !disableSubscriptionCheck) {
            return undefined;
        }
        // Do not allow upsell for pipl
        if (identity === null || identity === void 0 ? void 0 : identity.isPipl) {
            return undefined;
        }
        // Entitlements currently takes into consideration:
        //  - whether user consent is enabled
        //  - user has a business license
        if (!((_a = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _a === void 0 ? void 0 : _a.ShowConsumerUpsell)) {
            return undefined;
        }
        if (!disableWarmup) {
            warmupDimeInternal(experiences, launchDimeOptions);
        }
        return executeDimeFlow;
    }, [
        disableSubscriptionCheck,
        disableWarmup,
        executeDimeFlow,
        experiences,
        identity === null || identity === void 0 ? void 0 : identity.isMsa,
        identity === null || identity === void 0 ? void 0 : identity.isPipl,
        isSubscribedUser,
        launchDimeOptions,
        (_b = userEntitlements === null || userEntitlements === void 0 ? void 0 : userEntitlements.result) === null || _b === void 0 ? void 0 : _b.ShowConsumerUpsell,
    ]);
};
//# sourceMappingURL=useDime.js.map